module.exports = __webpack_public_path__ + "static/media/DesktopBg.21ca6177.png";